import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import {
  TourOptionDto,
  TourOptionListDto,
} from '@/features/dashboard/tourOptions/types/TourOptionDto.ts';
import { TourOptionUsageDto } from '@/features/dashboard/tourOptions/types/TourOptionUsageDto.ts';
import { TableDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { PageRequest } from '@/components/table/types/PageRequest.ts';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import { BookingListDto } from '@/features/dashboard/bookings/types/BookingListDto.ts';
import { buildPageRequestParams } from '@/components/table/types/TableUtil.ts';

const tourOptionsApi = {
  create: async (
    tourOption: Omit<TourOptionDto, 'id' | 'orderIndex'>,
  ): Promise<TourOptionDto> => {
    return await fetchPrivateApi<TourOptionDto>(
      'POST',
      `tour-options`,
      tourOption,
    );
  },
  update: async (
    optionId: string,
    tourOption: Omit<TourOptionDto, 'id' | 'orderIndex'>,
  ): Promise<TourOptionDto> => {
    return await fetchPrivateApi<TourOptionDto>(
      'PUT',
      `tour-options/${optionId}`,
      tourOption,
    );
  },
  getAll: async (tourId: string): Promise<TourOptionDto[]> => {
    return await fetchPrivateApi<TourOptionDto[]>(
      'GET',
      `tour-options/tour/${tourId}`,
    );
  },
  remove: async (tourId: string): Promise<void> => {
    return await fetchPrivateApi<void>('DELETE', `tour-options/${tourId}`);
  },
  getUsage: async (optionId: string): Promise<TourOptionUsageDto> => {
    return await fetchPrivateApi<TourOptionUsageDto>(
      'GET',
      `tour-options/${optionId}/usage`,
    );
  },
  reorder: async (tourId: string, optionIds: string[]): Promise<void> => {
    await fetchPrivateApi(
      'PUT',
      `tour-options/tour/${tourId}/order`,
      optionIds,
    );
  },

  getAllTable:
    (tourId: string) =>
    async (
      pageRequest: PageRequest,
      filterCriteria: FilterCriteriaDto,
    ): Promise<PagedDto<TourOptionListDto>> => {
      const params = buildPageRequestParams(pageRequest);
      return await fetchPrivateApi<PagedDto<TourOptionListDto>>(
        'POST',
        `tour-options/tour/${tourId}/all?${params.toString()}`,
        filterCriteria,
      );
    },

  getTableDefinition:
    (tourId: string) => async (): Promise<TableDefinitionDto> => {
      return await fetchPrivateApi<TableDefinitionDto>(
        'GET',
        `tour-options/tour/${tourId}/table-definition`,
      );
    },
};

export default tourOptionsApi;
